// path: src/pages/IPA/Negociacoes/pages/NegociacaoFornecedor/filtroAplicado.ts
import type { SuppliersExhibitionType } from '../../../../../store/useSuppliersExhibitionStore';

/** Os valores de filtro, chave por chave, como o gancho compartilhado os guarda. */
export type ValoresDeFiltro = Partial<Record<string, string[]>>;

/** O último filtro aplicado, preso ao agrupamento em que foi aplicado. */
export type FiltroAplicado = {
  agrupamento: SuppliersExhibitionType;
  valores: ValoresDeFiltro;
};

export const SEM_FILTRO: ValoresDeFiltro = {};

export const filtroAplicadoVazio = (agrupamento: SuppliersExhibitionType): FiltroAplicado => ({ agrupamento, valores: SEM_FILTRO });

/** Filtro aplicado em outro agrupamento não vale: trocar de agrupamento limpa os filtros (RN5). */
export const valoresAplicadosNoAgrupamento = (aplicado: FiltroAplicado, agrupamento: SuppliersExhibitionType): ValoresDeFiltro =>
  aplicado.agrupamento === agrupamento ? aplicado.valores : SEM_FILTRO;

/** Chave sem item marcado é o mesmo que chave ausente, e a ordem dos itens não importa. */
const normalizar = (valores: ValoresDeFiltro): Record<string, string[]> =>
  Object.keys(valores)
    .filter(chave => (valores[chave]?.length ?? 0) > 0)
    .sort()
    .reduce<Record<string, string[]>>((normalizado, chave) => {
      normalizado[chave] = [...(valores[chave] ?? [])].sort();
      return normalizado;
    }, {});

export const filtroVazio = (valores: ValoresDeFiltro): boolean => Object.keys(normalizar(valores)).length === 0;

export const filtrosIguais = (a: ValoresDeFiltro, b: ValoresDeFiltro): boolean => JSON.stringify(normalizar(a)) === JSON.stringify(normalizar(b));
